//#region src/core/ui/poster/core.ts
/**
* Turns playback and metadata into poster presentation state.
*
* Owns no image of its own: a binding finds one, supplies how it is faring through {@link PosterCore.setImageLoadState},
* and paints the result.
*
* @internal
*/
var PosterCore = class {
	#media = null;
	#loadState = "none";
	/** Supply the latest player state. Call before reading {@link PosterCore.getState}. */
	setMedia(media) {
		this.#media = media;
	}
	/** Supply how the binding's image is faring. */
	setImageLoadState(loadState) {
		this.#loadState = loadState;
	}
	/** Derive the presentation state to paint. */
	getState() {
		const media = this.#media;
		return {
			visible: !media.started,
			src: media.poster,
			loading: this.#loadState === "loading",
			loaded: this.#loadState === "loaded",
			error: this.#loadState === "error"
		};
	}
};
//#endregion
export { PosterCore };

//# sourceMappingURL=core.js.map